import { environment } from "src/environments/environment";
import { CoreToolbox } from "../../utils/core-toolbox";

/**
 * Generate url from env or local storate
 */

export class UrlFactory {
	static generateUrl() {
		const envServerUrl = environment.serverUrl;
		const storageServerUrl = CoreToolbox.storageService.getItem(
			"serverUrl"
		);

		if (!storageServerUrl) {
			return envServerUrl;
		}
		return storageServerUrl;
	}
}
